'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediumPrimaryIcon = exports.LargePrimaryIcon = exports.primaryIconComponent = undefined;
var _jsxFileName = 'src/index.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _index = require('./icons/index');
var icons = _interopRequireWildcard(_index);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Icon = function (_Component) {
  _inherits(Icon, _Component);
  function Icon(props) {
    _classCallCheck(this, Icon);
    var _this = _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).call(this, props));
    var componentName = props.type.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    }).replace(/\w/, function (match) {
      return match.toUpperCase();
    });
    _this.state = {
      Icon: (0, _glamorous2.default)(icons[componentName], {
        rootEl: 'svg'
      })({
        height: '1em',
        width: '1em',
        fill: 'currentColor',
        verticalAlign: '-0.14em',
        fontSize: props.large ? '4.5rem' : undefined
      })
    };
    return _this;
  }
  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        onClick = _props.onClick,
        large = _props.large,
        type = _props.type,
        rest = _objectWithoutProperties(_props, ['onClick', 'large', 'type']);
      var onClickProps = {
        onClick: onClick,
        role: 'button',
        tabIndex: 0,
        cursor: 'pointer'
      };
      return _react2.default.createElement(this.state.Icon, Object.assign({}, typeof onClick !== 'undefined' ? onClickProps : {}, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        },
        __self: this
      }));
    }
  }]);
  return Icon;
}(_react.Component);
Icon.propTypes = {
  type: _propTypes.string.isRequired,
  className: _propTypes.string,
  onClick: _propTypes.func,
  large: _propTypes.bool
};
Icon.defaultProps = {
  className: '',
  onClick: undefined,
  large: false
};
exports.default = Icon;
var primaryIconComponent = function primaryIconComponent(size) {
  PrimaryIconComponent.propTypes = {
    theme: _propTypes.object.isRequired,
    css: _propTypes.object
  };
  PrimaryIconComponent.defaultProps = {
    css: undefined
  };
  function PrimaryIconComponent(_ref) {
    var theme = _ref.theme,
      css = _ref.css,
      rest = _objectWithoutProperties(_ref, ['theme', 'css']);
    return _react2.default.createElement(Icon, Object.assign({
      css: Object.assign({
        color: theme.colorPrimary,
        fontSize: size
      }, css)
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60
      },
      __self: this
    }));
  }
  return (0, _glamorous.withTheme)(PrimaryIconComponent);
};
exports.primaryIconComponent = primaryIconComponent;
var LargePrimaryIcon = exports.LargePrimaryIcon = primaryIconComponent('6rem');
var MediumPrimaryIcon = exports.MediumPrimaryIcon = primaryIconComponent('4rem');